export class GetValidWorkItemRequest {
    Vehicle_VIN = '';
    AccountNumber = '';
}
